const axios = require("axios").default;

import mode from "./mode";

export default class dataService {
  constructor(dataPath) {
    this.dataPath = dataPath;
  }
  getMode() {
    return new Promise((resolve) => {
      axios
        .get(`${process.env.VUE_APP_DATA_URL}${this.dataPath}/mode.json`)
        .then((response) => {
          switch (response.data.mode) {
            case "artist":
              resolve(mode.ByArtistMode);
              break;
            case "headliner":
              resolve(mode.ByHeadlinerMode);
              break;
            case "day":
              resolve(mode.ByDayMode);
              break;
            case "full":
              resolve(mode.FullMode);
              break;
            default:
              console.error(
                "unable to determine view mode, defaulting to artist only"
              );
              resolve(mode.ByArtistMode);
              break;
          }
        });
    });
  }
  getArtistsData() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.VUE_APP_DATA_URL}${this.dataPath}/artists.json`)
        .then((response) => {
          const dataPath = this.dataPath;
          const detailPromises = Object.keys(response.data).map((prop) => {
              const key = response.data[prop];
            return axios
              .get(`${process.env.VUE_APP_DATA_URL}${dataPath}/${key._id}.json`)
              .then((detailResponse) => {
                return {
                id: key._id,
                title: key.title,
                photo: key.photo_suffix,
                  detail: detailResponse.data,
                billingOrder: key.billingOrder ? key.billingOrder : 0,
                };
                    })
                    .catch((err) => {
                      console.error(err);
                      console.error(`no data found for key ${key._id}`);
                return null;
                    });
              });

          Promise.all(detailPromises)
            .then((detailedArtists) => {
              const filteredArtists = detailedArtists.filter(
                (artist) => artist !== null
              );
              // uncomment the following line if you want to download the complete artist json on page refresh
              // this.downloadJSON(filteredArtists, "artists_complete.json");
              // be sure to comment out the above line before building or committing
              resolve(filteredArtists);
            })
            .catch((err) => {
              console.error("error getting artist details!");
              reject(err);
            });
        })
        .catch((err) => {
          console.error("error getting artists!");
          reject(err);
        });
    });
  }

  downloadJSON(data, filename) {
    const dataStr = JSON.stringify(data, null, 2);
    const blob = new Blob([dataStr], { type: "application/json" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getShowsData() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.VUE_APP_DATA_URL}${this.dataPath}/shows.json`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          console.error("error getting shows!");
          reject(err);
        });
    });
  }
}
